module.exports = __webpack_public_path__ + "static/media/proposicao-icone.c2a75951.svg";